module.exports = __webpack_public_path__ + "static/OKR-illustration-1114907b80f08515939010f3909173c9.png";